import { createContext, useContext } from "react";

export const ProposalCardCollapsedContext = createContext<boolean>(false);

export function useProposalCardIsCollapsed(): boolean {
  return useContext(ProposalCardCollapsedContext);
}
